import { useSelector } from 'react-redux';

import { Types } from '@store/types';

const initialState = {
	supplierInfo: {},
	documents: {},
	supplierBankInfo: {},
	onboardingStatus: {}
};

const OnboardingReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SAVE_SUPPLIER_ONBOARDING_STATUS:
			return { ...state, onboardingStatus: action.payload };
		case Types.SAVE_SUPPLIER_INFORMATION:
			return { ...state, supplierInfo: action.payload };
		case Types.SAVE_SUPPLIER_BANK_INFORMATION:
			return { ...state, supplierBankInfo: action.payload?.[0] || {} };
		case Types.SAVE_SUPPLIER_DOCUMENTS:
			return { ...state, documents: action.payload };
		default:
			return state;
	}
};

export const useOnboardingStatus = () =>
	useSelector((state) => state.supplierOnboardingStore.onboardingStatus);
export const useSupplierInfo = () => useSelector((state) => state.supplierOnboardingStore.supplierInfo);
export const useSupplierBankInfo = () =>
	useSelector((state) => state.supplierOnboardingStore.supplierBankInfo);
export const useSupplierDocuments = () => useSelector((state) => state.supplierOnboardingStore.documents);

export default OnboardingReducer;
